export default "__VITE_ASSET__8d353bf2__"